var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-secondary",on:{"click":function($event){return _vm.openSupplies({product: _vm.product})}}},[_vm._v("Zum Zubehör")])
}
var staticRenderFns = []

export { render, staticRenderFns }